import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { ROUTE_ENUM } from "enums";
import {
  RegisterPage,
  LoginPage,
  EnterCodePage,
  RegisterAdminPage,
  LoginAdminPage,
  LinkExpiredPage,
  ResetPasswordPage,
  CreateNewPasswordPage,
  UsersPage,
  ProfilePage,
  CompaniesPage,
  SvgTestPage,
  Homepage,
  AnalyzesPage,
  MarketInfo,
  PostPage,
  RodoPage,
  PrivacyPolicyPage,
  TermsOfServicePage,
  ContactPage,
  SuccessorPage,
  SuccessorResetPasswordPage,
} from "screens";
import { Suspense } from "react";
import { ProtectedRoute, toggleCookieButtonVisibility } from "utils";
import { PageWrapper } from "shared";
import { useLocation } from "react-router";
const RoutesComponent: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    toggleCookieButtonVisibility(location.pathname);
  }, [location.pathname]);

  return (
    <Suspense fallback={"..."}>
      <Routes>
        <Route
          path={ROUTE_ENUM.HOME}
          element={
            <PageWrapper>
              <Homepage />
            </PageWrapper>
          }
        />
        <Route path={ROUTE_ENUM.REGISTER} element={<RegisterPage />} />
        <Route
          path={ROUTE_ENUM.REGISTER_ADMIN}
          element={<RegisterAdminPage />}
        />
        <Route path={ROUTE_ENUM.LOGIN} element={<LoginPage />} />
        <Route path={ROUTE_ENUM.LOGIN_ADMIN} element={<LoginAdminPage />} />
        <Route path={ROUTE_ENUM.LINK_EXPIRED} element={<LinkExpiredPage />} />
        <Route path={ROUTE_ENUM.ENTER_CODE} element={<EnterCodePage />} />
        <Route path={ROUTE_ENUM.RODO} element={<RodoPage />} />

        <Route
          path={ROUTE_ENUM.TERMS_OF_SERVICE}
          element={<TermsOfServicePage />}
        />
        <Route
          path={ROUTE_ENUM.PRIVACY_POLICY}
          element={<PrivacyPolicyPage />}
        />
        <Route path={`${ROUTE_ENUM.DASHBOARD}/*`} element={<ProtectedRoute />}>
          <Route
            path={ROUTE_ENUM.PROFILE.replace(`${ROUTE_ENUM.DASHBOARD}/`, "")}
            element={<ProfilePage />}
          />
          <Route
            path={ROUTE_ENUM.CONTACT.replace(`${ROUTE_ENUM.DASHBOARD}/`, "")}
            element={<ContactPage />}
          />
          <Route
            path={ROUTE_ENUM.SUCCESSOR.replace(`${ROUTE_ENUM.DASHBOARD}/`, "")}
            element={<SuccessorPage />}
          />
          <Route
            path={ROUTE_ENUM.SUCCESSOR_RESET_PASSWORD.replace(
              `${ROUTE_ENUM.DASHBOARD}/`,
              ""
            )}
            element={<SuccessorResetPasswordPage />}
          />
          <Route
            path={ROUTE_ENUM.COMPANIES.replace(`${ROUTE_ENUM.DASHBOARD}/`, "")}
            element={<CompaniesPage />}
          />
          <Route
            path={ROUTE_ENUM.ANALYSIS.replace(`${ROUTE_ENUM.DASHBOARD}/`, "")}
            element={<AnalyzesPage />}
          />
          <Route
            path={ROUTE_ENUM.MARKET_INFORMATION.replace(
              `${ROUTE_ENUM.DASHBOARD}/`,
              ""
            )}
            element={<MarketInfo />}
          />
          <Route
            path={ROUTE_ENUM.POST.replace(`${ROUTE_ENUM.DASHBOARD}/`, "")}
            element={<PostPage />}
          />
        </Route>
        <Route
          path={`${ROUTE_ENUM.DASHBOARD}/*`}
          element={<ProtectedRoute isAdminOnly />}
        >
          <Route
            path={ROUTE_ENUM.USERS.replace(`${ROUTE_ENUM.DASHBOARD}/`, "")}
            element={<UsersPage />}
          />
        </Route>
        <Route
          path={ROUTE_ENUM.RESET_PASSWORD}
          element={<ResetPasswordPage />}
        />
        <Route path={ROUTE_ENUM.SVG_TEST} element={<SvgTestPage />} />
        <Route
          path={ROUTE_ENUM.CREATE_NEW_PASSWORD}
          element={<CreateNewPasswordPage />}
        />
      </Routes>
    </Suspense>
  );
};

export default RoutesComponent;
